import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ManifestComponent } from './components/manifest/manifest.component';
import { ManifestService } from './manifest.service';
import {Trip2ThemeModule} from '../../../trip2-theme/trip2-theme.module';
import {DirectivesModule} from '../../../directives/directives.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ApprovalTripModule} from '../../trip-reservations/approval-trip/approval-trip.module';
import { AgGridModule } from 'ag-grid-angular';

@NgModule({
  imports: [
    CommonModule,
    Trip2ThemeModule,
    DirectivesModule,
    ReactiveFormsModule,
    FormsModule,
    ApprovalTripModule,
    AgGridModule.withComponents([])
  ],
  declarations: [ManifestComponent],
  exports:  [ManifestComponent],
  providers: [ManifestService]
})
export class ManifestModule { }



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/manifest/manifest.module.ts